import { PageWrapper } from "@/components";
import { routes } from "@/helpers";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faTriangleExclamation, faBug } from "@fortawesome/sharp-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Tabs } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useProjectContext } from "@/providers";
import { RisksTab } from "./components/RisksTab";
import { IssuesTab } from "./components/IssuesTab";

export const RisksAndIssues = () => {
  const {
    project,
  } = useProjectContext();

  const pageTitle = () => {
    let projectTitle;
    if (project?.projectNumber && project?.projectName) {
      projectTitle = intl.formatMessage(
        { id: "project.tabTitle" },
        { id: project?.projectNumber, name: project?.projectName }
      );
    } else {
      projectTitle = intl.formatMessage({ id: "project.title" });
    }
    return projectTitle + ' | ' + intl.formatMessage({ id: "risksAndIssues.title" });
  };

  const intl = useIntl();
  const [currentTab, setCurrentTab] = useState<'risks' | 'issues'>('risks');

  const [risksTotalCount, setRisksTotalCount] = useState<number | undefined>(undefined);
  const [issuesTotalCount, setIssuesTotalCount] = useState<number | undefined>(undefined);

  const tabs = [
    {
      key: 'risks',
      label: <>
        {intl.formatMessage({ id: "risksAndIssues.tabs.risks" })}
        {' '}
        <Badge count={risksTotalCount ?? 0} color="purple" showZero />
      </>,
      icon: <FontAwesomeIcon size="lg" icon={faTriangleExclamation as IconProp} />,
      children: (
        <RisksTab
          publicProjectId={project?.id}
          onTotalCountChange={setRisksTotalCount}
        />
      ),
      forceRender: true,
    },
    {
      key: 'issues',
      label: <>
        {intl.formatMessage({ id: "risksAndIssues.tabs.issues" })}
        {' '}
        <Badge count={issuesTotalCount ?? 0} color="blue" showZero />
      </>,
      icon: <FontAwesomeIcon size="lg" icon={faBug as IconProp} />,
      children: (
        <IssuesTab
          publicProjectId={project?.id}
          onTotalCountChange={setIssuesTotalCount}
        />
      ),
      forceRender: true,
    },
  ];

  return (
    <PageWrapper
      pageTitle={pageTitle()}
      backButtonRoute={routes.projects.get(project?.id)}
    >
      <Tabs
        data-test-id="risks-and-issues-tabs"
        activeKey={currentTab}
        items={tabs}
        onChange={(key) => setCurrentTab(key as 'risks' | 'issues')}
      />
    </PageWrapper>
  );
};
